var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "w-100" },
    [
      _c(
        "div",
        {
          staticClass: "container-fluid fixed-top",
          staticStyle: {
            width: "100%",
            "z-index": "10",
            "padding-left": "0",
            "padding-right": "0",
            background: "#ffffff"
          },
          attrs: { id: "nav-info", role: "navigation" }
        },
        [_c("interview-navi", { attrs: { navData: _vm.pageData } })],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: {
            "quote-panel-open": _vm.quotePanelStatus,
            "quote-panel-close": !_vm.quotePanelStatus,
            bundle:
              _vm.flowType === "bundle" ||
              _vm.flowType === "cabundle" ||
              _vm.flowType === "rabundle"
          },
          attrs: { role: "main" }
        },
        [
          _c(
            "form",
            {
              on: {
                keydown: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  return _vm.submitted($event)
                }
              }
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _vm.blurbs.formtop && _vm.blurbs.formtop.visible
                ? _c(
                    "div",
                    {
                      staticClass: "d-flex justify-content-center mx-auto mb-1"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "alert alert-primary my-0 py-2 w-50",
                          attrs: { role: "note" }
                        },
                        [
                          _c("div", { staticClass: "row no-gutters" }, [
                            _vm._m(1),
                            _vm._v(" "),
                            _c("div", {
                              staticClass:
                                "col d-inline-block my-auto smaller-font-content",
                              domProps: {
                                innerHTML: _vm._s(_vm.blurbs.formtop.content)
                              }
                            })
                          ])
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "row no-gutters mx-0" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "form-row mx-0" }, [
                    _c("div", { staticClass: "col-12 col-md-6 px-0" }, [
                      _vm.hasFields(
                        "Residential & Health Insurance",
                        _vm.pageFieldsArray_1
                      ) ||
                      _vm.hasFields(
                        "Residential Insurance",
                        _vm.pageFieldsArray_1
                      )
                        ? _c(
                            "div",
                            { staticClass: "mr-md-4 shadow-sm pb-2 rounded" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "py-2 mt-1 mb-2 pl-2 bg-ltblue text-white rounded-top"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.healthInsurance,
                                          expression: "healthInsurance"
                                        }
                                      ],
                                      attrs: {
                                        "data-v-0ea1833e": "",
                                        role: "heading",
                                        "aria-level": "3"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "Residential & Health\n                    Insurance"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.healthInsurance,
                                          expression: "!healthInsurance"
                                        }
                                      ],
                                      attrs: {
                                        "data-v-0ea1833e": "",
                                        role: "heading",
                                        "aria-level": "3"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "Residential\n                    Insurance\n                  "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.pageFieldsArray_1, function(
                                item,
                                key
                              ) {
                                return _c("form-block", {
                                  key: key,
                                  ref: item.field_name,
                                  refInFor: true,
                                  staticClass: "form-group mx-3",
                                  attrs: { formdata: item }
                                })
                              })
                            ],
                            2
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 col-md-6 px-0" }, [
                      _vm.hasFields("Auto Insurance", _vm.pageFieldsArray_2)
                        ? _c(
                            "div",
                            { staticClass: "ml-md-4 shadow-sm pb-2 rounded" },
                            [
                              _vm._m(2),
                              _vm._v(" "),
                              _vm._l(_vm.pageFieldsArray_2, function(
                                item,
                                key
                              ) {
                                return _c("form-block", {
                                  key: key,
                                  ref: item.field_name,
                                  refInFor: true,
                                  staticClass: "form-group mx-3",
                                  attrs: { formdata: item }
                                })
                              })
                            ],
                            2
                          )
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("hr", { staticClass: "mx-2" }),
                  _vm._v(" "),
                  _vm.blurbs.formbottom && _vm.blurbs.formbottom.visible
                    ? _c(
                        "div",
                        {
                          staticClass: "d-flex justify-content-center mx-auto"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "alert alert-primary my-0 py-2 w-50",
                              attrs: { role: "note" }
                            },
                            [
                              _c("div", { staticClass: "row no-gutters" }, [
                                _vm._m(3),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass:
                                    "col d-inline-block my-auto smaller-font-content",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.blurbs.formbottom.content
                                    )
                                  }
                                })
                              ])
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getContinueLabelName() != "" && _vm.continueEnabled
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "form-row justify-content-center mx-0 my-3"
                        },
                        [
                          _c("div", { staticClass: "col-8 text-center" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary",
                                attrs: { type: "submit" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.submitted($event)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.getContinueLabelName()))]
                            )
                          ])
                        ]
                      )
                    : _vm._e()
                ])
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("dev-auto-fill", { attrs: { pageData: _vm.pageData } }),
      _vm._v(" "),
      _vm.$store.state.buttonState.quoteSummaryData &&
      _vm.$store.state.buttonState.quoteSummaryData.quote_status === "Bound"
        ? _c("form-alerts", {
            class: {
              "policy-bound-alert": true,
              "margin-25": _vm.quotePanelStatus
            },
            attrs: { pageData: _vm.policyBindError }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "required row mx-0" }, [
      _c("div", { staticClass: "col-12 px-0 text-left" }, [
        _c("span", { staticClass: "star" }, [_vm._v("*")]),
        _vm._v("Required to run carrier quotes.\n          "),
        _c("hr")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-inline-block pr-2 my-auto" }, [
      _c("img", {
        attrs: {
          width: "25px",
          height: "25px",
          src: require("../../../../assets/info-circle-blue.svg"),
          alt: "info"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "py-2 mt-1 mb-2 pl-2 bg-ltblue text-white rounded-top" },
      [
        _c(
          "div",
          {
            attrs: { "data-v-0ea1833e": "", role: "heading", "aria-level": "3" }
          },
          [_vm._v("Auto Insurance")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-inline-block pr-2 my-auto" }, [
      _c("img", {
        attrs: {
          width: "25px",
          height: "25px",
          src: require("../../../../assets/info-circle-blue.svg"),
          alt: "info"
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5fc9397e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fc9397e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/interview/Auto/RC1/PriorInsurance.vue
// module id = null
// module chunks = 